import { AbsoluteFill, Sequence } from "remotion";
import { COLORS, SLIDE_DURATIONS } from "./constants";
import {
  S01Title,
  S02Shift,
  S03Hermes,
  S04Harness,
  S05Groundhog,
  S06MeetEAKC,
} from "./scenes01";
import {
  S07Fragmented,
  S08Matrix,
  S09Already,
  S10Gaps,
  S11BigIdea,
  S12Anatomy,
} from "./scenes02";
import {
  S13Kinds,
  S14Action1,
  S15Action2,
  S16Lifecycle,
  S17Sources,
  S18Applier,
} from "./scenes03";
import {
  S19Nudge,
  S20Learned,
  S21Timeline,
  S22Inspector,
  S23ChatPast,
  S24ChatNow,
} from "./scenes04";
import {
  S25Gap,
  S26Flywheel,
  S27Advantages,
  S28Reality,
  S29Gallery,
  S30Closing,
} from "./scenes05";

/* 30 slides — "Building Hermes-Inspired Capabilities into EAKC" · 24 May 2026 */
const SCENES: React.FC[] = [
  S01Title,
  S02Shift,
  S03Hermes,
  S04Harness,
  S05Groundhog,
  S06MeetEAKC,
  S07Fragmented,
  S08Matrix,
  S09Already,
  S10Gaps,
  S11BigIdea,
  S12Anatomy,
  S13Kinds,
  S14Action1,
  S15Action2,
  S16Lifecycle,
  S17Sources,
  S18Applier,
  S19Nudge,
  S20Learned,
  S21Timeline,
  S22Inspector,
  S23ChatPast,
  S24ChatNow,
  S25Gap,
  S26Flywheel,
  S27Advantages,
  S28Reality,
  S29Gallery,
  S30Closing,
];

const STARTS: number[] = SLIDE_DURATIONS.map((_, i) =>
  SLIDE_DURATIONS.slice(0, i).reduce((a, b) => a + b, 0),
);

export const HermesEAKC: React.FC = () => {
  return (
    <AbsoluteFill style={{ backgroundColor: COLORS.bg }}>
      {SCENES.map((Comp, i) => (
        <Sequence key={i} from={STARTS[i]} durationInFrames={SLIDE_DURATIONS[i]}>
          <Comp />
        </Sequence>
      ))}
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
